import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form as FormikForm, ErrorMessage } from "formik";
import { Form, Row, Col, Modal, Container } from "react-bootstrap";
import * as Yup from "yup";
import { UserDataContext } from "../components/UserDataContext";
import { registerLocale } from "react-datepicker";
import { addDays, isAfter } from "date-fns";
import { format } from "date-fns";
import { useParams } from "react-router-dom";
import "../components/button.css";
import { Autocomplete, TextField } from "@mui/material";
import Alerts from "../components/Alerts";
import { marginBottom } from "../App";
import Button from "@mui/material/Button";
import BlockSharpIcon from "@mui/icons-material/BlockSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { pl } from "date-fns/locale";
import ClearIcon from "@mui/icons-material/Clear";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import VN from "../components/VN";
import KeyIcon from "@mui/icons-material/Key";
import PassChangeUser from "./PassChangeUser";
import MenuItem from "@mui/material/MenuItem";
import { Box, Select } from "@mui/material";
import { apiRequest } from "../components/Config";

const validationSchema = () =>
  Yup.object().shape({
    user: Yup.string().required("Użytkownik jest wymagany"),
    fullName: Yup.string().required("Imię i nazwisko są wymagane"),
    city: Yup.string().required("Miejscowość jest wymagana"),
    selectedDate: Yup.date()
      .nullable()
      .required("Data jest wymagana")
      .test(
        "is-after-today",
        "Data musi być późniejsza niż dzisiaj",
        (value) => value && isAfter(value, new Date())
      ),
  });
registerLocale("pl", pl);

export default function EditUser() {
  const { id } = useParams();
  const { userData } = useContext(UserDataContext);
  const navigate = useNavigate();
  const [userUserData, setUserUserData] = useState({});
  const [userPermission, setUserPermission] = useState();
  const [disabled, setDisabled] = useState(false);
  const [initialFormValues, setInitialFormValues] = useState({
    user: "",
    fullName: "",
    city: "",
    email: "",
    phone: "",
    selectedDate: null,
    expire: "",
    is_active: "",
    permbuild: "",
    expertise: "",
    permId: "",
  });
  const [show, setShow] = useState(false);
  const [showPassChange, setShowPassChange] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleted, setDeleted] = useState(null);
  const [buttonText, setButtonText] = useState();
  const [apiResponse, setApiResponse] = useState({});
  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setSelectedId(id);
    setShow(true);
  };
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [permissionsAll, setPermissionsAll] = useState([]);
  const ClearApiResponse = () => {
    setShowApiResponse(false);
  };
  const [selectedUsers, setSelectedUsers] = useState([]);
  const handleSubmit = async (values, { setSubmitting }) => {
    const formatted = format(values.selectedDate, "yyyy-MM-dd");
    values["expire"] = formatted;
    values["id"] = id;

    try {
      const response = await apiRequest(`edituser/${id}`, "POST", values);
      if (response.error_msg === 200) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Informacja",
          severity: "success",
          info: "Dane zaktualizowane!",
        });
      }
      if (response.error_msg === 559) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Uwaga",
          severity: "error",
          info: "Dane nie zostały zaktualizowane.",
        });
      }
      if (response.error_msg === 600) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Uwaga",
          severity: "error",
          info: "Błąd po stronie serwera. Skontaktuj się z Administratorem.",
        });
      }
    } catch (error) {
      setShowApiResponse(true);
      setApiResponse({
        title: "Uwaga",
        severity: "error",
        info: "Nie udało się zaktualizować!",
      });
      console.error("There was an error editing the user!", error);
    } finally {
      setSubmitting(false);
    }
  };
  const handleDelete = async () => {
    try {
      const response = await apiRequest(`updateuser/${id}`, "POST", {
        id: selectedId,
        is_active: deleted,
      });
      // sprawdź response i w zależności od tego ustaw setDeleted
      setShow(false);
      setDeleted((prev) => (prev === 0 ? 1 : 0));
      setButtonText((prev) =>
        prev === "Przywróć dostęp" ? "Zablokuj" : "Przywróć dostęp"
      );
    } catch (error) {
      console.error("Błąd podczas próby zablokowania użytkownika:", error);
    }
  };

  useEffect(() => {
    if (userData) {
      const fetchData = async () => {
        try {
          const response = await apiRequest("getpossibilities", "GET");
          if (Array.isArray(response)) {
            setOptions(response);
          } else {
            setOptions([]);
          }
        } catch (error) {
          console.log(error.message);
        }
      };
      fetchData();
    }
  }, [userData, inputValue]);

  useEffect(() => {
    if (userData && !["1", "3"].includes(userData.permId)) {
      navigate("/nopermission");
    }
  }, [userData]);

  const handlePass = (id) => {
    setShowPassChange(!showPassChange);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiRequest(`user/${id}`, "GET");
        if (response[0]) {
          setUserUserData(response[0]);
          setInitialFormValues({
            user: response[0].user || "",
            fullName: response[0].fullName || "",
            city: response[0].city || "",
            email: response[0].email || "",
            phone: response[0].phone || "",
            selectedDate: response[0].expire
              ? new Date(response[0].expire)
              : null,
            expire: response[0].expire || "",
            is_active: response[0].is_active || "",
            permbuild: response[0].permbuild || "",
            expertise: response[0].expertise || "",
            permId: response[0].permId || "",
          });
          setUserPermission(response[0].permId);
        }
      } catch (error) {
        console.log(error.message);
      }
    };
    if (userData && userData.userId) {
      fetchData();
    }
  }, [userData]);

  useEffect(() => {
    if (userPermission === "2") {
      setDisabled(true);
    }
  }, [userUserData, userPermission]);

  useEffect(() => {
    if (
      initialFormValues.is_active === "0" &&
      initialFormValues.is_active !== ""
    ) {
      setButtonText("Przywróć dostęp");
      setDeleted(1);
    }
    if (
      initialFormValues.is_active === "1" &&
      initialFormValues.is_active !== ""
    ) {
      setButtonText("Zablokuj");
      setDeleted(0);
    }
  }, [initialFormValues.is_active]);

  useEffect(() => {
    if (userData) {
      const fetchData = async () => {
        try {
          const response = await apiRequest(
            `getuserposiibilities/${id}`,
            "GET"
          );
          if (JSON.stringify(response) !== JSON.stringify(selectedUsers)) {
            setSelectedUsers(response);
          }
        } catch (error) {
          console.log(error.message);
        }
      };
      fetchData();
    }
  }, [userData, inputValue, selectedOption, selectedUsers, deleted]);

  const handleRemovePossibility = (idP, user) => {
    async function deletePossibility() {
      try {
        const response = await apiRequest("deletepossibility", "POST", {
          id: idP,
          user: user,
        });
        if (response.rowsDeleted === 1) {
          setSelectedUsers((prevPossibilities) =>
            prevPossibilities.filter(
              (possibilities) => possibilities.userId !== id
            )
          );
        } else {
          console.error("Nie udało się usunąć");
        }
      } catch (error) {
        console.error("Wystąpił błąd podczas usuwania", error);
      }
    }
    deletePossibility();
  };

  const handleSaveView = (possibility) => {
    async function insertEvent() {
      try {
        await apiRequest("insertpossibility", "POST", {
          possibility: possibility,
          id: id,
        });
      } catch (error) {
        console.log("Wystąpił błąd:", error);
      }
    }
    insertEvent();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiRequest("permissions");
        if (userPermission !== "2") {
          const filteredData = response.filter((item) => item.id !== 2);
          setPermissionsAll(filteredData);
        } else {
          setPermissionsAll(response);
        }
      } catch (error) {
        console.log(error.message);
      }
    };

    if (userData && userData.userId) {
      fetchData();
      const intervalId = setInterval(fetchData, 100000);
      return () => clearInterval(intervalId);
    }
    if (userPermission === "2") {
      setReadOnly(true);
    }
  }, [userData, userPermission]);

  return (
    <div>
      <VN userData={userData} />
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Potwierdzenie</Modal.Title>
        </Modal.Header>
        <Modal.Body>Czy na pewno ?</Modal.Body>
        <Modal.Footer>
          <Button variant="outlined" onClick={handleClose}>
            Anuluj
          </Button>
          <Button variant="contained" onClick={handleDelete}>
            {deleted === 0 ? "Blokuj" : "Przywróć"}
          </Button>
        </Modal.Footer>
      </Modal>
      <Container>
        <h4>Edycja</h4>

        <Formik
          initialValues={initialFormValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ isSubmitting, setValues, values, handleChange }) => (
            <ThemeProvider theme={theme}>
              <FormikForm>
                <Row className="align-items-start" style={{ marginBottom }}>
                  <Col md="2" style={{ marginBottom }}>
                    <Form.Group controlId="formUser">
                      <TextField
                        name="user"
                        label="Konto logowania Wykonawcy"
                        variant="outlined"
                        value={values.user}
                        onChange={(e) => {
                          handleChange(e);
                          ClearApiResponse();
                        }}
                        fullWidth
                        inputProps={{ readOnly: true }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="2" style={{ marginBottom }}>
                    <Form.Group controlId="formFullName">
                      <TextField
                        name="fullName"
                        label="Nazwisko i Imię Wykonawcy"
                        variant="outlined"
                        value={values.fullName}
                        onChange={(e) => {
                          handleChange(e);
                          ClearApiResponse();
                        }}
                        fullWidth
                      />

                      <ErrorMessage
                        name="fullName"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="2" style={{ marginBottom }}>
                    <Form.Group controlId="formCity">
                      <TextField
                        name="city"
                        label="Miasto zamieszkania Wykonawcy"
                        variant="outlined"
                        value={values.city}
                        onChange={(e) => {
                          handleChange(e);
                          ClearApiResponse();
                        }}
                        fullWidth
                      />

                      <ErrorMessage
                        name="city"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="2" style={{ marginBottom }}>
                    <Form.Group controlId="formEmail">
                      <TextField
                        name="email"
                        label="E-mail"
                        variant="outlined"
                        value={values.email}
                        onChange={(e) => {
                          handleChange(e);
                          ClearApiResponse();
                        }}
                        fullWidth
                      />

                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="2" style={{ marginBottom }}>
                    <Form.Group controlId="formPhone">
                      <TextField
                        name="phone"
                        label="Telefon"
                        variant="outlined"
                        value={values.phone}
                        onChange={(e) => {
                          handleChange(e);
                          ClearApiResponse();
                        }}
                        fullWidth
                      />

                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="2" style={{ marginBottom }}>
                    <Form.Group
                      controlId="formDate"
                      className="d-flex align-items-center"
                    >
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={pl}
                      >
                        <DatePicker
                          label="Wybierz datę ważności konta"
                          value={values.selectedDate}
                          onChange={(date) => {
                            setValues({ ...values, selectedDate: date });
                            ClearApiResponse();
                          }}
                          format="yyyy-MM-dd"
                          slotProps={{ textField: { variant: "outlined" } }}
                          minDate={addDays(new Date(), 1)}
                        />
                      </LocalizationProvider>
                      <ErrorMessage
                        name="selectedDate"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </Col>

                  <Col md="2" style={{ marginBottom }}>
                    <ThemeProvider theme={theme}>
                      <Box sx={{ minWidth: 120 }}>
                        <Form.Group controlId="formPerm">
                          <Select
                            id="permId"
                            name="permId"
                            value={values.permId}
                            label="Uprawnienia"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            fullWidth
                            disabled={disabled}
                          >
                            {permissionsAll.map((item) => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.description}
                              </MenuItem>
                            ))}
                          </Select>
                        </Form.Group>
                      </Box>
                    </ThemeProvider>
                  </Col>
                </Row>

                {userPermission == 2 && (
                  <Row style={{ marginBottom }}>
                    <Col md="4" style={{ marginBottom }}>
                      <Form.Group controlId="formPermBuild">
                        <TextField
                          name="permbuild"
                          label="Uprawnienia budowlane"
                          variant="outlined"
                          value={values.permbuild}
                          onChange={(e) => {
                            handleChange(e);
                            ClearApiResponse();
                          }}
                          fullWidth
                          multiline
                          rows={4}
                        />

                        <ErrorMessage
                          name="permbuild"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                    <Col md="4" style={{ marginBottom }}>
                      <Form.Group controlId="formExpertise">
                        <TextField
                          name="expertise"
                          label="Rzeczoznawstwo"
                          variant="outlined"
                          value={values.expertise}
                          onChange={(e) => {
                            handleChange(e);
                            ClearApiResponse();
                          }}
                          fullWidth
                          multiline
                          rows={4}
                        />

                        <ErrorMessage
                          name="expertise"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                )}
                <Row className="align-items-start" style={{ marginBottom }}>
                  <Col md={2} className="d-flex align-items-center">
                    {userUserData &&
                      initialFormValues.is_active !== "" &&
                      id !== userData.userId && (
                        <Button
                          variant="outlined"
                          onClick={() => handleShow(id)}
                        >
                          <BlockSharpIcon />
                          {buttonText}
                        </Button>
                      )}
                  </Col>

                  <Col md={3} className="d-flex align-items-center">
                    <Button
                      variant="outlined"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      <EditSharpIcon />
                      Zapisz
                    </Button>
                  </Col>
                  <Col md={3} className="d-flex align-items-center">
                    <Button variant="outlined" onClick={() => handlePass(id)}>
                      <KeyIcon />
                      Ustaw hasło
                    </Button>
                  </Col>
                </Row>
              </FormikForm>
            </ThemeProvider>
          )}
        </Formik>
      </Container>
      {showPassChange && <PassChangeUser userId={id} />}
      <hr></hr>
      {userPermission == 2 && (
        <>
          <Container>
            <Row style={{ marginBottom }}>
              <Col md={3}>
                <Autocomplete
                  value={selectedOption}
                  onChange={(event, newValue) => {
                    if (newValue) setSelectedOption(null);
                    handleSaveView(newValue.id);
                  }}
                  inputValue={inputValue}
                  onInputChange={(event, newInputValue) =>
                    setInputValue(newInputValue)
                  }
                  options={options}
                  getOptionLabel={(option) => {
                    if (typeof option === "string") {
                      return option;
                    }
                    return option.possibility ? option.possibility : "";
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Wyszukaj uprawnienia do dodania"
                      variant="outlined"
                    />
                  )}
                />
              </Col>

              <Col md={6}>
                <h4>Zapisane uprawnienia i deklaracje budowlane</h4>
              </Col>
            </Row>

            <Row style={{ marginBottom }}>
              <Col md={3}></Col>
              <Col>
                {Array.isArray(selectedUsers) &&
                  selectedUsers.map((possibility, index) => (
                    <span key={possibility.possibilityId || index}>
                      <div>
                        <b>
                          {index + 1}
                          {".      "}
                        </b>
                        {possibility.possibility}
                        <Button
                          variant="text"
                          onClick={() =>
                            handleRemovePossibility(
                              possibility.possibilityId,
                              possibility.userId
                            )
                          }
                        >
                          <ClearIcon />
                        </Button>
                        {index < selectedUsers.length - 1 && ""}{" "}
                      </div>
                    </span>
                  ))}
              </Col>
            </Row>
          </Container>
        </>
      )}
    </div>
  );
}
